<mb-header-bar [notificationCount]="notificationCount"></mb-header-bar>

<!-- Main menu -->
<wb-header-navigation aria-label="{{ 'MAIN_NAVIGATION' | translate }}">
  @if (mainMenu$ | async; as menu) {
    @for (item of menu; track item.id) {
      <wb-header-navigation-item
        label="Open {{ 'MENU.' + item.id + '.NAME' | translate }} menu"
        (click)="toggleMenu(2, item)"
        [active]="isActive(item)"
      >
        {{ 'MENU.' + item.id + '.NAME' | translate }}
      </wb-header-navigation-item>
    }
  }

  <div class="desktop-end">
    <wb-header-navigation-item class="hover-animation" (click)="openMyContent()">
      <div class="my-mb-media">
        <wb-icon slot="icon" name="bds/bookmark/24"></wb-icon>
        {{ 'MY_CONTENT' | translate }}
        <div class="notification-icon" [ngClass]="{ 'show-notification': !!notificationCount }">
          <wb-icon class="bell" name="notification"></wb-icon>
          <wb-counter [value]="notificationCount" [max]="9" variant="secondary"></wb-counter>
        </div>
      </div>
    </wb-header-navigation-item>
  </div>
</wb-header-navigation>

<!-- Bread crumbs -->
@if (breadcrumbs$ | async; as breadcrumbs) {
  @if (isMinimized || breadcrumbs.length || currentMediaQuery === 'mq3' || currentMediaQuery === 'mq4') {
    <div class="breadcrumbs" [class.light]="lightPage$ | async">
      <wb-breadcrumbs theme="dark">
        @if (isMinimized) {
          <wb-icon id="to-top" class="chevron btn btn-plain" name="bds/chevron-up/24" (click)="scrollTop()"></wb-icon>
        }
        <wb-horizontal-scroll theme="dark" hide-arrow-navigation>
          @if (breadcrumbs.length) {
            <wb-breadcrumb mbRouterLink="/"> Start </wb-breadcrumb>
          }
          @for (crumb of breadcrumbs; track crumb.label) {
            <wb-breadcrumb [mbRouterLink]="crumb.link | translate">{{ crumb.label | translate }}</wb-breadcrumb>
          }
        </wb-horizontal-scroll>
      </wb-breadcrumbs>
      <div class="breadcrumbs-end">
        <wb-header-navigation-item class="hover-animation" (click)="openMyContent()">
          <div class="my-mb-media">
            <wb-icon slot="icon" name="bds/bookmark/24"></wb-icon>
            {{ 'MY_CONTENT' | translate }}
            <div class="notification-icon" [ngClass]="{ 'show-notification': !!notificationCount }">
              <wb-icon class="bell" name="notification"></wb-icon>
              <wb-counter [value]="notificationCount" [max]="9" variant="secondary"></wb-counter>
            </div>
          </div>
        </wb-header-navigation-item>
      </div>
    </div>
  }
}

<mb-fly-in></mb-fly-in>
